<template>
    <v-content>
            <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
        <v-row>

            <v-col
                cols="12"
                sm="4"
                md="3"
                xl="2"
                    v-for="title in snackbar.dashboardItems.list"
                    v-bind:key="title.link"
                    class="viewCard"

            >
                <router-link :to="`/departmentDepoDashboard/${snackbar.routeID}`"  v-if="title.count">
                    <v-card :elevation="10"
                            class="custom-design text-center"
                            height="140"
                            width="300">
                        <v-list-item link>
                            <v-list-item-content>
                                <v-list-item-title class="subtitle-1 mt-1 pa-4">
                                    <div>
                                        <span>{{title.name}}</span>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="custom-footer">
                            <v-list-item-content>
                                <v-divider></v-divider>
                                <v-list-item-title class="card-footer subtitle-1 pa-4">
                                    <div>
                                        <span>{{$t('total')}} {{$t('department')}}: {{title.count}}</span>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </router-link>
                <v-card :elevation="10"
                        class="custom-design text-center"
                        height="140"
                        width="300"
                        v-else>
                    <v-list-item link>
                        <v-list-item-content>
                            <v-list-item-title class="subtitle-1 mt-1 pa-4">
                                <div>
                                    <span>{{title.name}}</span>
                                </div>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="custom-footer">
                        <v-list-item-content>
                                <v-divider></v-divider>
                            <v-list-item-title class="card-footer subtitle-1 mt-1 pa-4">
                                <div>
                                    <!--<span>Total Department: {{title?.count}}</span>-->
                                </div>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
            </v-col>

            <v-col
                cols="12"
                sm="4"
                md="3"
                xl="2"
                    class="viewCard"
            >
                <router-link :to="`/departmentBranchDashboard/${snackbar.routeID}`">
                    <v-card :elevation="10"
                            class="custom-design text-center"
                            height="140"
                            width="300">
                        <v-list-item link>
                            <v-list-item-content>
                                <v-list-item-title class="white--text subtitle-1 mt-1 pa-4">
                                    <div>
                                        <span>{{$t('department')}}</span>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="custom-footer">
                            <v-list-item-content>
                                <v-divider></v-divider>
                                <v-list-item-title class="card-footer subtitle-1 mt-1 pa-4">
                                    <div>
                                        <!--<span>Total Count : {{snackbar.countData.details?.count}} </span>-->
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </router-link>
            </v-col>
        </v-row>
    </v-content>
</template>

<script>
    import axios from "axios";
    import {mapGetters} from "vuex";

    export default {
        name: "BranchList",

        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            branchPermission(){
                return this.isSuperAdmin || this.isCompany || this.isDepartment
            },
            isSuperAdmin() {
                return this.userRole === "SuperAdmin"
            },
            isCompany() {
                return this.userRole === "Company"
            },
            isDepartment() {
                return this.userRole === "Department"
            },
            breadcrumbItems() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: this.usersData.dashBoard,
                        exact: true
                    },
                    {
                        text: this.$t('provisional_offices'),
                        disabled: false,
                        to: "/CompanyList",
                        exact: true
                    },
                    {
                        text: this.snackbar.dashboardItems.companyName,
                        disabled: false,
                        to: `/branchAdminDashboard/${this.snackbar.dashboardItems.companyID}`,
                        exact: true
                    }, {
                        text: this.snackbar.dashboardItems.branchName,
                        disabled: true,
                        to: "/company",
                        exact: true
                    },

                ]
            }
        },
        data() {
            return {
                breadDetails:[],
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                    },
                    {
                        label: 'Code',
                        field: 'code',
                    },
                    {
                        label: 'Address',
                        field: 'address',
                    },
                    {
                        label: 'Phone Number',
                        field: 'phoneNumber',
                    },
                    {
                        label: 'Email',
                        field: 'email',
                    },
                    {
                        label: 'Website',
                        field: 'website',
                    },
                    {
                        label: 'Established Year',
                        field: 'establishedYear',
                    }
                ],
                rows: [],
                branchData: {
                    totalRows: 0,
                    editItemIndex: null,
                    deleteFormData: {}
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "branchID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                snackbar: {
                    routeID:this.$route.params.id,
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    createFormComponent: false,
                    editFormComponent: false,
                    dialogDelete: false,
                    breadcrumbItems: [],
                    dashboardItems:[],
                    dynamicComponent: {
                        current: 'BranchForm'
                    },
                    countData:[]
                }
            };
        },
        methods: {

            loadItems() {
                this.snackbar.isLoading = true;
                let param = {
                    branchID: parseInt(this.$route.params.id)
                };
                axios.get('Branch/BranchDepoList', {params:param}).then(response=>{
                    this.snackbar.dashboardItems = response.data
                    this.breadCrumbsItem()
                })

                axios.get('Branch/DepartmentCount',{params:{
                        BranchID:this.$route.params.id
                    }}).then(response=>{
                        this.snackbar.countData = response.data
                })
            },
                
        },
        mounted() {
            this.loadItems()
        },

    }
</script>

<style lang="scss" scoped>
    .custom-design {
        transition: transform 0.2s, box-shadow 0.2s; /* Add box-shadow to the transition */
        cursor: pointer;
        box-shadow: 0 0 0 transparent; /* Start with no shadow */
        background: deepskyblue !important;
    }

        .custom-design:hover {
            transform: scale(1.03);
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.5); /* Add a shadow on hover */
        }

    .card-footer {
        background-color: #f0f0f0;
        background: linear-gradient(to bottom, #efeeed7a, #b3b3b3);
    }

    .custom-footer {
        padding-top: 0.6rem;
        padding-left: 0px;
        padding-right: 0px
    }
</style>
